import { useEffect } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';

import { getGAClientId } from '../utils/getGaClientId';

export function useTrackCTAImpression(eventData: Record<string, unknown>) {
	const { isIntersecting, ref } = useIntersectionObserver({
		threshold: 0.1,
	});

	useEffect(() => {
		if (isIntersecting) {
			const { hostname, pathname } = window.location;
			const searchParams = new URLSearchParams({
				...eventData,
				gaClientId: getGAClientId(document.cookie),
				pageUrl: pathname,
			});

			fetch(
				`https://tracking.${getTrackingOrigin(hostname)}/uk-cta-impressions-pixel.png?${searchParams.toString()}`,
			);
		}
	}, [eventData, isIntersecting]);

	return ref;
}

function getTrackingOrigin(hostname: Location['hostname']) {
	switch (true) {
		case hostname.includes('oddschecker.com'):
			return 'oddschecker.com';
		default:
			return 'stg.occloud.io';
	}
}
